import { TextField } from "@mui/material";
import { useDebounce } from "hooks/useDebounce";
import { useEffect, useState } from "react";
import useTableState from "recoilStore/Table/useTableState";
import styles from "./SearchBar.module.scss";

interface SearchBarProps {
    tableId: string;
}

function SearchBar({ tableId }: SearchBarProps) {
    const { resetStateTrigger, setSearchBarText, setTablePage } = useTableState(tableId);
    const [locaSearchBarText, setLocalSearchBarText] = useState("");

    const debouncedSetSearch = useDebounce((value: string) => {
        setSearchBarText(value);
        setTablePage(0);
    }, 200);

    // Needed to reset searchBarText when searchBar connected to tables in different tabs
    useEffect(() => {
        setLocalSearchBarText("");
    }, [tableId, resetStateTrigger]);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setLocalSearchBarText(value);
        debouncedSetSearch(value);
    };

    return (
        <div className={styles.searchBarContainer}>
            <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="Search in this table..."
                value={locaSearchBarText}
                onChange={handleSearchChange}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                        "& fieldset": {
                            border: "1px solid var(--audette-gray-300)",
                            borderRadius: "4px",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "var(--audette-pink) !important",
                            borderWidth: "2px",
                            borderRadius: "4px",
                        },
                    },
                }}
            />
        </div>
    );
}

export default SearchBar;
